import { createModuleBuilder } from '@evidentid/dashboard-commons/app';

import ButtonExample from './components/ButtonExample.vue';
import DropdownsExample from './components/DropdownsExample.vue';
import ExpandableExample from './components/ExpandableExample.vue';
import FormExample from './components/FormExample.vue';
import LabelBadgeExample from './components/LabelBadgeExample.vue';
import PopoverExample from './components/PopoverExample.vue';
import DesignExamplesColors from './views/DesignExamplesColors.vue';
import DesignExamplesComponents from './views/DesignExamplesComponents.vue';
import DesignExamplesIndex from './views/DesignExamplesIndex.vue';
import DesignExamplesModals from './views/DesignExamplesModals.vue';

const sharedMeta = {
    userOnly: true,
    evidentOnly: true,
};

export const designExamplesModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/examples/',
            name: 'examples',
            component: DesignExamplesIndex,
            meta: { ...sharedMeta, title: 'Design examples' },
        },
        {
            path: '/examples/colors',
            name: 'examples.colors',
            component: DesignExamplesColors,
            meta: { ...sharedMeta, title: 'Colors' },
        },
        {
            path: '/examples/components',
            redirect: { name: 'examples.components.badges' },
            component: DesignExamplesComponents,
            meta: { ...sharedMeta, title: 'Components' },
            children: [
                {
                    path: 'buttons',
                    name: 'examples.components.buttons',
                    component: ButtonExample,
                    meta: { ...sharedMeta, title: 'Buttons' },
                },
                {
                    path: 'badges',
                    name: 'examples.components.badges',
                    component: LabelBadgeExample,
                    meta: { ...sharedMeta, title: 'Badges' },
                },
                {
                    path: 'modals',
                    name: 'examples.components.modals',
                    component: DesignExamplesModals,
                    meta: { ...sharedMeta, title: 'Modals' },
                },
                {
                    path: 'expandable',
                    name: 'examples.components.expandable',
                    component: ExpandableExample,
                    meta: { ...sharedMeta, title: 'Expandable' },
                },
                {
                    path: 'form',
                    name: 'examples.components.form',
                    component: FormExample,
                    meta: { ...sharedMeta, title: 'Form' },
                },
                {
                    path: 'dropdowns',
                    name: 'examples.components.dropdowns',
                    component: DropdownsExample,
                    meta: { ...sharedMeta, title: 'Dropdowns' },
                },
                {
                    path: 'popover',
                    name: 'examples.components.popover',
                    component: PopoverExample,
                    meta: { ...sharedMeta, title: 'Popover' },
                },
            ],
        },
    ])
    .end();
